import React, { useEffect, useState, useRef } from "react";
import { Image, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

//STYLES
import * as SlotStyles from "../styles/slot";

function VideoSlot(props) {
    const navigate = useNavigate();

    const textRef = useRef(null);

    const [text, setText] = useState();
    const [textOverflow, setTextOverflow] = useState(false);

    useEffect(() => {
        setText(props.title);
    }, []);

    return (
        <div style={SlotStyles.video_listCardBody} onClick={props.onClick.bind(this, props.videoURL)}>
            <div style={SlotStyles.video_cardImage}>
                <Image src={props.thumbnail} style={SlotStyles.image} />
            </div>
            <div ref={textRef} style={SlotStyles.video_listCardText}>
                {text}
            </div>
        </div>
    );
}

export default VideoSlot;
